import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from './button.js';
import { Card, CardContent } from './card.js';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import 'lucide-react';
import 'react';
import '../../lib/toast.js';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'react-day-picker';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import './radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function EmptyState({ icon, title, description, action, className }) {
    return (jsx(Card, { className: cn('border-dashed', className), children: jsxs(CardContent, { className: "flex flex-col items-center justify-center py-12 px-6 text-center", children: [icon && (jsx("div", { className: "w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center text-primary", children: icon })), jsx("h3", { className: "text-lg font-semibold mb-2", children: title }), description && jsx("p", { className: "text-muted-foreground mb-6 max-w-sm", children: description }), action && (jsxs(Button, { onClick: action.onClick, variant: action.variant || 'default', size: "sm", children: [action.icon && jsx(action.icon, { className: "h-4 w-4 mr-2" }), action.label] }))] }) }));
}
// Simple empty state for tables and lists (no border, transparent background)
function EmptyTableState({ icon, title, description, action, className, }) {
    return (jsxs("div", { className: cn('flex flex-col items-center justify-center py-12 px-6 text-center', className), children: [icon && (jsx("div", { className: "w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center text-primary", children: icon })), jsx("h3", { className: "text-base font-medium mb-2", children: title }), description && jsx("p", { className: "text-sm text-muted-foreground mb-6 max-w-sm", children: description }), action && (jsxs(Button, { onClick: action.onClick, variant: action.variant || 'default', size: "sm", children: [action.icon && jsx(action.icon, { className: "h-4 w-4 mr-2" }), action.label] }))] }));
}

export { EmptyState, EmptyTableState };
//# sourceMappingURL=empty-state.js.map
